import { render, staticRenderFns } from "./screen-blocker.vue?vue&type=template&id=62347398&scoped=true&"
import script from "./screen-blocker.vue?vue&type=script&lang=js&"
export * from "./screen-blocker.vue?vue&type=script&lang=js&"
import style0 from "./screen-blocker.vue?vue&type=style&index=0&id=62347398&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62347398",
  null
  
)

export default component.exports